<script>
  import IconTitle from '@/components/ProtectedBag/partials/IconTitle'

  export default {
    name: 'ModalArticle',
    props: {
      generalTitle: {
        type: String,
        required: false,
        default: null
      },
      title: {
        type: String,
        required: false,
        default: null
      },
      icon: {
        type: String,
        required: false,
        default: null
      },
      description: {
        type: String,
        required: false,
        default: null
      },
      iconBottom: {
        type: String,
        required: false,
        default: null
      },
      labelBottom: {
        type: String,
        required: false,
        default: null
      },
      backgroundColor: {
        type: String,
        required: false,
        default: ''
      }
    },
    components: {
      IconTitle
    },
    computed: {
      iconBottomPath () {
        return require(`@/assets/svg/${this.iconBottom}.svg`)
      }
    }
  }
</script>

<template>
  <article
    class="modal-article"
    :style="{
      '--ma-background-color': backgroundColor
    }"
  >
    <h3 class="modal-article__general-title" v-if="generalTitle"><strong>{{ generalTitle }}</strong></h3>
    <IconTitle v-if="title" :icon="icon" :title="title" />
    <p v-if="description">{{ description }}</p>
    <slot />
    <figure class="modal-article__bottom" v-if="labelBottom">
      <img v-if="iconBottom" :src="iconBottomPath" :alt="labelBottom">
      <figcaption v-if="labelBottom"><strong>{{ labelBottom }}</strong></figcaption>
    </figure>
  </article>
</template>

<style lang="scss" scoped>
  .modal-article {
    background-color: var(--ma-background-color, transparent);
    padding: 24px;

    @media (max-width: 360px) {
      padding: 16px;
    }

    &:only-child {
      margin-bottom: 60px;
    }

    em {
      color: #6320E9;
      font-style: normal;
      font-weight: 500;
    }

    p {
      margin-bottom: 0;
      color: #535355;
      font-family: 'Rubik', sans-serif;
      font-size: 16px;
      line-height: 28px;
    }

    p + p,
    p + div {
      margin-top: 24px;
    }

    & + .modal-article {
      border-top: 1px solid var(--ma-background-color, #D5D5D7);
    }

    &__general-title {
      font-size: 20px;
      line-height: 24px;
      margin-bottom: 24px;
    }

    &__bottom {
      display: grid;
      grid-template-columns: 18px auto;
      gap: 8px;
      align-items: center;
      color: #6320E9;
      font-size: 14px;
      margin-top: 16px;
    }
  }
</style>
